import React from "react";
import "./Background.css";

const Background = () => {
  return <div className="Background"></div>;
};

export default Background;
